module.exports = __webpack_public_path__ + "img/base-commander.ee5a1266.png";